import { forkJoin, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import { Configuration } from '../../../analytics-core/interfaces/configuration.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-layout',
	styleUrls: ['../styles/layout.component.css'],
	templateUrl: '../views/layout.component.html'
})
export class LayoutComponent implements OnInit, AfterViewInit {
	public configuration: Configuration;
	public content: string;

	constructor(private http: HttpClient, private analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.configuration = this.analyticsDataModel.config;
	}

	ngAfterViewInit(): void {
		const url = `assets/partner-assets/${this.getDirectoryName()}/views/layout.html`;
		const breadcrumb = this.http.get(url, { responseType: 'text' });
		forkJoin([breadcrumb]).subscribe(
			(responses: any[]) => {
				let html = '';
				for (const resp of responses) {
					html += resp;
				}
				this.content = html;
			},
			(err) => console.error(err)
		);
	}

	getDirectoryName(): string {
		if (this.configuration.useDefaultHtmls) {
			return `default-${this.configuration.version.toLowerCase()}`;
		}
		return this.configuration.partner.directoryName;
	}
}
